<template>
  <div class="ds-whitespace-nowrap">
    <span v-if="alwaysInStock">
      {{ $t('In Stock') }}
    </span>
    <span
      v-else-if="outOfStock"
      class="ds-font-bold ds-text-error-700"
    >
      {{ $t('Out of stock') }}
    </span>
    <span
      v-else-if="belowThreshold"
      class="ds-font-bold ds-text-warning-700"
    >
      {{ $tc('Only {count} left', quantity, { count: quantity }) }}
    </span>
    <span v-else>
      {{ quantity }}
    </span>
    <div
      v-if="reserved"
      class="ds-inline"
    >
      <AkTooltipInformation
        v-if="product.variants.length > 1"
        trigger="hover"
        placement="right"
        type="invert"
        class="ds-inline-block"
      >
        <template #container>
          <span
            v-for="v of product.variants"
            :key="v.sku"
            class="ds-block"
          >{{
            $t('brand.products.reservedVariantsTooltip', { reservedQuantity: v.stock.reserved_quantity ?? 0, sku: v.sku })
          }}</span>
        </template>
        <span class="product-stock-tag"> {{ reserved }} {{ reserved > 1 ? $t('reserves') : $t('reserved') }} </span>
      </AkTooltipInformation>
      <span
        v-else
        class="product-stock-tag"
      >
        {{ reserved }} {{ reserved > 1 ? $t('reserves') : $t('reserved') }}
      </span>
    </div>
  </div>
</template>
<script lang="ts">
import Product from '@monolith/legacy/types/product';
import { ProductCollectionItem } from '@monolith/legacy/types/account/product-collections';
import { defineComponent } from 'vue';
import { isProductOutOfStock } from '@monolith/legacy/services/product-variants';
import { AkTooltipInformation } from '@ankorstore/design-system';

const STOCK_THRESHOLD = 5;

export default defineComponent({
  name: 'ProductsTableStock',
  components: {
    AkTooltipInformation,
  },
  props: {
    product: {
      type: Object as () => Product | ProductCollectionItem,
      required: true,
    },
  },
  computed: {
    quantity(): number {
      return this.product.variants.reduce((count, v) => count + v.stock.stock_quantity, 0);
    },
    reserved(): number {
      return this.product.variants.reduce((count, v) => count + v.stock.reserved_quantity, 0);
    },
    alwaysInStock(): boolean {
      return !!this.product.variants.find(({ stock }) => stock.is_always_in_stock, 0);
    },
    belowThreshold(): boolean {
      return this.quantity <= STOCK_THRESHOLD;
    },
    outOfStock(): boolean {
      return isProductOutOfStock(this.product as Product);
    },
  },
});
</script>
<style lang="scss" scoped>
@import '@css/vue-import';
.product-stock-tag {
  @apply ds-bg-info-100 ds-px-2 ds-py-0.5 ds-ml-2;
  @apply ds-rounded-sm ds-text-xs ds-whitespace-nowrap;
  --tw-bg-opacity: 1;
}
</style>
